import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface SiteNavbarProps {
  /** true when rendered on the home page so in-page anchors work directly */
  home?: boolean;
}

const NAV_ITEMS = [
  { label: 'Services', target: 'services', toPage: '/services' },
  { label: 'Industries', target: 'industries' },
  { label: 'Why Us', target: 'why-us' },
  { label: 'Contact', target: 'contact' },
];

export default function SiteNavbar({ home = false }: SiteNavbarProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-focus-2-line text-xl"></i>
          </div>
          <span className={`text-2xl font-bold tracking-tight ${light ? 'text-background-50' : 'text-primary-700'}`}>
            Acu-Comp
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
          {NAV_ITEMS.map((item) =>
            item.toPage ? (
              <Link
                key={item.label}
                to={item.toPage}
                className={`cursor-pointer whitespace-nowrap hover:text-accent-500 transition ${
                  light ? 'text-background-50/90' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={home ? `#${item.target}` : `/#${item.target}`}
                className={`cursor-pointer whitespace-nowrap hover:text-accent-500 transition ${
                  light ? 'text-background-50/90' : 'text-foreground-700'
                }`}
              >
                {item.label}
              </a>
            ),
          )}
        </nav>

        <a
          href="tel:18007800632"
          className="hidden md:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-md text-sm font-semibold whitespace-nowrap cursor-pointer transition"
        >
          <i className="ri-phone-line"></i> 1-800-780-0632
        </a>
      </div>
    </header>
  );
}